import { IIndexable, key } from 'core-ts-types';
import { merge } from 'lodash4';
import { slotType } from '../../../../global/builders/ap_generic_slot_builder';
import { APProgramSlot } from '../../../../global/builders/ap_program_slot_builder';
import { IPlanFeedbackCourseGroup } from './plan_feedback_course_group_builder';
import { PlanFeedbackProgramSlot } from './plan_feedback_program_slot_builder';
import { IPlanFeedbackTerm } from './plan_feedback_term_builder';
import { planFeedbackTransactionType } from './plan_feedback_transaction_type';

export interface IPlanFeedbackProgramSlot {
  desc: string;
  id: number;
  nk: string;
  slot: number;
  term_slot_group?: number;
  course_group: IPlanFeedbackCourseGroup['course_group'] & {
    slot_type: slotType;
  };
}
export interface IPlanFeedbackProgramSlotCourse {
  cd: string;
  desc: string | null;
  id: number;
  title: string;
}
export interface IPlanFeedbackCourseProgramSlot extends IPlanFeedbackProgramSlot {
  courses: IPlanFeedbackProgramSlotCourse[];
}
export interface IPlanFeedbackCourse {
  course: {
    cd: string;
    credits: number;
    dept: number;
    desc: string | null;
    id: number;
    level: number;
    nk: string;
    number: null | number;
    subject: number;
    title: string;
  };
  diff: planFeedbackTransactionType;
  id: key;
  nk: string;
  program_slot: number | null;
  program_slot_obj: IPlanFeedbackProgramSlot;
  from_program_slot: number | null;
  from_program_slot_obj?: IPlanFeedbackProgramSlot | null;
  term?: number | null;
  from_term?: number | null;
  resolution: number | null;
  is_locked: boolean;
  lock_modified?: boolean;
  from_comment?: string | null;
  comment?: string | null;
}

export interface IPlanFeedbackCourseMeta extends IIndexable {
  _term?: IPlanFeedbackTerm['term'];
  _from_term?: IPlanFeedbackTerm['term'];
  id: key;
  _programSlot: APProgramSlot;
  _feedbackProgramSlot?: PlanFeedbackProgramSlot;
}

export class PlanFeedbackCourse implements IPlanFeedbackCourse {
  course: IPlanFeedbackCourse['course'];
  diff: IPlanFeedbackCourse['diff'];
  id: IPlanFeedbackCourse['id'];
  nk: IPlanFeedbackCourse['nk'];
  program_slot: IPlanFeedbackCourse['program_slot'];
  program_slot_obj: IPlanFeedbackCourse['program_slot_obj'];
  from_program_slot: IPlanFeedbackCourse['from_program_slot'];
  from_program_slot_obj: IPlanFeedbackCourse['from_program_slot_obj'];
  term?: IPlanFeedbackCourse['term'];
  from_term?: IPlanFeedbackCourse['from_term'];
  resolution: IPlanFeedbackCourse['resolution'];
  is_locked: IPlanFeedbackCourse['is_locked'];
  lock_modified?: IPlanFeedbackCourse['lock_modified'];
  from_comment?: IPlanFeedbackCourse['from_comment'];
  comment?: IPlanFeedbackCourse['comment'];

  constructor(planFeedbackCourse: Partial<PlanFeedbackCourse>) {
    merge(this, planFeedbackCourse);
  }

  static build(inTakeSurveyPoll: Partial<PlanFeedbackCourse>): PlanFeedbackCourse {
    return new PlanFeedbackCourse(inTakeSurveyPoll);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/builders/plan_feedback_course_builder.ts